const DAY = 86400000;
export function readOffline(kind, userId, fallback = []) {
  if (!userId) return fallback;
  try {
    const row = JSON.parse(localStorage.getItem(`polka_offline_${kind}_${userId}`) || 'null');
    return row && row.at <= Date.now() && Date.now() - row.at < DAY && (!Array.isArray(fallback) || Array.isArray(row.data)) ? row.data : fallback;
  } catch { return fallback; }
}
export function writeOffline(kind, userId, data) {
  if (!userId) return;
  try {
    const value = JSON.stringify({ at: Date.now(), data: Array.isArray(data) ? data.slice(0, 500) : data });
    if (value.length < 1000000) localStorage.setItem(`polka_offline_${kind}_${userId}`, value);
  } catch { /* Storage is optional and must not break a confirmed server save. */ }
}
export function sessionFingerprint(token) {
  let hash = 2166136261;
  for (const char of token || '') hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
  return (hash >>> 0).toString(36);
}
export function updateOffline(kind, userId, update) { writeOffline(kind, userId, update(readOffline(kind, userId))); }
